import script from "./paymentMethod.vue?vue&type=script&setup=true&lang=js"
export * from "./paymentMethod.vue?vue&type=script&setup=true&lang=js"

import "./paymentMethod.vue?vue&type=style&index=0&id=2162be77&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2162be77"]])

export default __exports__